export default __webpack_public_path__ + "static/media/NewFooterMob.653065b4.svg";